import { useCallback, useState } from 'react'

// Chakra UI inspired utility hook
export const useDisclosure = (
  initial = false,
  callback?: (isNowOpen: boolean) => void,
) => {
  const [isOpen, setIsOpen] = useState(initial)

  const toggle = useCallback(() => {
    setIsOpen((s) => {
      const isNowOpen = !s
      callback?.(isNowOpen)
      return isNowOpen
    })
  }, [callback])

  const close = useCallback(() => {
    setIsOpen(false)
    callback?.(false)
  }, [callback])

  const open = useCallback(() => {
    setIsOpen(true)
    callback?.(true)
  }, [callback])

  return {
    isOpen,
    toggle,
    close,
    open,
  }
}
